import ParsingDfa16Table from "../../parsing/parsing_dfa_16table.js";
/**
 * DFA State machine states for parsing a comment.
 */
export var ATTRIBUTE_PARSE_TYPE;
(function (ATTRIBUTE_PARSE_TYPE) {
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["INVALID"] = 0] = "INVALID";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["NUMBER"] = 1] = "NUMBER";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["ENUM"] = 2] = "ENUM";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["STRING"] = 3] = "STRING";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["REFERENCE"] = 4] = "REFERENCE";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["CONTAINER"] = 5] = "CONTAINER";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["HEXBITS"] = 6] = "HEXBITS";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["NULL"] = 7] = "NULL";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["DERIVED"] = 8] = "DERIVED";
    ATTRIBUTE_PARSE_TYPE[ATTRIBUTE_PARSE_TYPE["INLINE_INSTANCE"] = 9] = "INLINE_INSTANCE";
})(ATTRIBUTE_PARSE_TYPE || (ATTRIBUTE_PARSE_TYPE = {}));
/**
 * Maps characters to attributes for discriminators in STEP.
 */
export default class StepAttributeMap extends ParsingDfa16Table {
    /**
     * Construct the table.
     */
    constructor() {
        super(ATTRIBUTE_PARSE_TYPE.NUMBER);
        /**
         * Get the attribute for a character.
         *
         * @param char The character to match.
         * @return {ATTRIBUTE_PARSE_TYPE} The matching type.
         */
        this.get = (char) => {
            return super.get(char, ATTRIBUTE_PARSE_TYPE.NUMBER);
        };
        this.range(ATTRIBUTE_PARSE_TYPE.NUMBER, "0", "9", ATTRIBUTE_PARSE_TYPE.NUMBER);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "-+", ATTRIBUTE_PARSE_TYPE.NUMBER);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, ".", ATTRIBUTE_PARSE_TYPE.ENUM);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "'", ATTRIBUTE_PARSE_TYPE.STRING);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "#", ATTRIBUTE_PARSE_TYPE.REFERENCE);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "(", ATTRIBUTE_PARSE_TYPE.CONTAINER);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "\"", ATTRIBUTE_PARSE_TYPE.HEXBITS);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "$", ATTRIBUTE_PARSE_TYPE.NULL);
        this.set(ATTRIBUTE_PARSE_TYPE.NUMBER, "*", ATTRIBUTE_PARSE_TYPE.DERIVED);
        this.range(ATTRIBUTE_PARSE_TYPE.NUMBER, "A", "Z", ATTRIBUTE_PARSE_TYPE.INLINE_INSTANCE);
    }
}
StepAttributeMap.Instance = new StepAttributeMap();
